import styled from "styled-components";

export const DateTimeSpan = styled.span<{ $nonBreaking: boolean }>`
  white-space: ${(props) => (props.$nonBreaking ? "nowrap" : "normal")};
`;
